import { useEffect, useState } from 'react';
import { api } from 'services/api';
import { DoctorRecord } from 'types/doctorRecord';

// `reloadKey` muda quando o cadastro é salvo, para a ficha buscar os dados atualizados.
export function useFetchDoctorRecord(id: string | undefined, reloadKey = 0) {
  const [record, setRecord] = useState<DoctorRecord | null>(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);

  useEffect(() => {
    if (!id) return;

    setLoading(true);
    setError(false);

    api
      .get<DoctorRecord>(`/doctors/${id}/record`)
      .then(response => setRecord(response.data))
      .catch(() => setError(true))
      .finally(() => setLoading(false));
  }, [id, reloadKey]);

  return { record, loading, error };
}
